<template>
  <BaseModal
    :show="show"
    @close="close"
  >
    <div class="modal-body text-center">
      <header class="text-center pb-4 border-b border-grey">
        <h3
          class="my-0 font-bold"
          v-text="'Are you sure?'"
        />
      </header>
      <div>
        <div
          v-if="membershipGroup"
          class="flex justify-center items-baseline my-8"
          v-text="`Are you sure you want to remove this member from ${membershipGroup.attributes.title}?`"
        />
      </div>
    </div>
    <div class="modal-footer text-center mt-4">
      <button
        type="button"
        class="btn"
        @click.prevent="remove"
        v-text="'Remove'"
      />
      <button
        type="button"
        class="ml-4"
        @click="close"
        v-text="'Cancel'"
      />
    </div>
  </BaseModal>
</template>

<script type="text/babel">
export default {
  name: 'RemoveMembershipFromMembershipGroupModal',
  computed: {
    membershipUuid() {
      return this.$store.state.membership.removeMembershipFromMembershipGroupModal.membershipUuid
    },
    membershipGroup() {
      return this.$store.state.membership.removeMembershipFromMembershipGroupModal.membershipGroup
    },
    show() {
      return this.$store.state.membership.removeMembershipFromMembershipGroupModal.open
    },
  },
  methods: {
    remove() {
      this.$api.active().delete(`memberships/${this.membershipUuid}/membership-groups/${this.membershipGroup.uuid}`)
        .then(() => {
          this.$emit('membershipHasBeenRemovedFromMembershipGroup')

          this.close()
        }).catch(() => {
          this.$store.commit('baseAddNotification', {
            type: 'error',
            text: 'There was a problem removing the member from the group.',
            timeout: false,
          })

          this.close()
        })
    },
    close() {
      this.$store.commit('membershipCloseRemoveMembershipFromMembershipGroupModal')
    },
  },
}
</script>
